import { AdminTableBodyProps } from './admin-table-body-props';
import React from 'react';
import { TableBody } from '@mint/ui';
import styled from 'styled-components';

// TODO: Remove the style hacks.
//      ref: https://github.com/RobotSnacks/mint/issues/27
export const AdminTableBody = styled(TableBody)`
  && {
    overflow-y: auto !important;
    overflow-x: hidden !important;
  }
`;
